.container {
  margin: auto;
  /* width is set dynamically in JSX */
  /* 48px is left padding, same for editor */
  max-width: calc(100% - 2 * 48px);

  font-size: 12px;
  line-height: 24px;
  color: var(--color-subtle);
}

.container input {
  margin: 0;
  padding: 0;
  appearance: none;
  background: transparent;
  border: none;
  outline: none;

  color: var(--color-text);
  font-size: inherit;
  line-height: inherit;
}

.container [style="font-family: monospace; white-space: pre"] {
  font-family: inherit !important;
}

.container [style^="color:"] {
  color: var(--color-subtle) !important;
}
